/* eslint-disable import/no-named-as-default */
import { Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Page from 'src/components/Page'
import UserList from './UserList'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: 10,
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
  },
  title: {
    marginBottom: 15,
  },
}))

export const User = () => {
  const classes = useStyle()

  return (
    <Page
      className={classes.root}
      title="افیلیت مارکتینگ"
    >
      <Grid className={classes.root}>
        <Typography className={classes.title} variant="h3" component="h3">افیلیت مارکتینگ</Typography>
        <Routes>
          <Route path="/" element={<UserList />} />
        </Routes>
      </Grid>
    </Page>
  )
}

export default User
